import React from "react";

// Lazy-loaded import of the Subscription component using React.lazy
export const SubscriptionManagement = React.lazy(() => import("./Subscription/index.page"));
